import {
  Application,
  BaseTexture,
  Graphics,
  Texture,
  RenderTexture,
  Sprite,
  filters,
  resources,
  BLEND_MODES
} from 'pixi.js'

import MediaStreamResource from '../util/MediaStreamResource'
import * as StackBlur from 'stackblur-canvas'

// prototype - v09 - using render texture to get smear effects again
export default () => {
  let app, gui, bodypix, maskCanvas, mctx, maskTexture, webcamVideo

  const bodypixOptions = {
    outputStride: 16, // 8, 16, or 32, default is 16
    segmentationThreshold: 0.4 // 0 - 1, defaults to 0.5
  }

  // stage size
  const SCALE = 0.5
  const W = 1280 * SCALE
  const H = 720 * SCALE

  // capture scale
  const CSCALE = 0.25
  const CW = W * CSCALE
  const CH = H * CSCALE

  // setup
  const setup = async () => {
    app = new Application({
      antialias: true,
      width: W,
      height: H,
      transparent: true
    })

    app.stage.interactive = true

    // Get webcam
    const capture = await navigator.mediaDevices.getUserMedia({ video: { width: CW, height: CH } })

    // MediaStream wraps Video and allows us to pass in the srcObject (instead of relying on 'src')
    const captureRes = new MediaStreamResource(capture)
    webcamVideo = captureRes.source
    webcamVideo.width = CW
    webcamVideo.height = CH

    // We have webcam.
    document.body.className = 'loading'

    // Setup sprites
    const captureSprite = new Sprite(new Texture(new BaseTexture(captureRes, { mipmap: false })))

    // video loops
    const videoRes = new resources.VideoResource('/video/tree_shadows.mp4')
    videoRes.source.loop = true
    videoRes.source.playbackRate = 0.5

    const videoRes2 = new resources.VideoResource('/video/liquid_pour_alpha.mp4')
    videoRes2.source.loop = true
    videoRes2.source.playbackRate = 0.25

    const videoSprite = new Sprite(new Texture(new BaseTexture(videoRes, { mipmap: false })))
    const videoSprite2 = new Sprite(new Texture(new BaseTexture(videoRes2, { mipmap: false })))

    // load bodyPix with video
    bodypix = await ml5.bodyPix(webcamVideo, bodypixOptions)

    document.body.className = 'loaded'

    // create canvas and texture for mask data
    maskCanvas = document.createElement('canvas')
    maskCanvas.width = CW
    maskCanvas.height = CH
    mctx = maskCanvas.getContext('2d')

    maskTexture = new Texture.from(maskCanvas)

    const maskSprite = new Sprite(maskTexture)

    // create two render textures... these dynamic textures will be used to draw the scene into itself
    let renderTexture = RenderTexture.create(app.screen.width, app.screen.height)
    let renderTexture2 = RenderTexture.create(app.screen.width, app.screen.height)
    const currentTexture = renderTexture

    // create a new sprite that uses the render texture we created above
    const outputSprite = new Sprite(currentTexture)
    // outputSprite.alpha = 0.99

    app.stage.addChild(outputSprite)

    // set sizes and add to stage
    const sprites = [captureSprite, videoSprite, maskSprite, videoSprite2]
    sprites.forEach((s) => {
      s.width = W
      s.height = H
      s.x = 0
      s.y = 0
      app.stage.addChild(s)
    })

    // alpha, mask, and filters
    captureSprite.alpha = 0.02
    captureSprite.filters = [new filters.BlurFilter(16)]

    videoSprite.alpha = 0.15
    videoSprite.mask = maskSprite

    videoSprite2.alpha = 0.05
    videoSprite2.blendMode = BLEND_MODES.MULTIPLY

    // show app
    document.querySelector('.content').appendChild(app.view)

    // show textures on screen for debugging
    // document.querySelector('.debug').appendChild(captureRes.source)
    // document.querySelector('.debug').appendChild(maskCanvas)

    // run the segmentation on the video, handle the results in a callback
    bodypix.segment(onSegment)

    let count = 0

    app.ticker.add(() => {
      count++

      // swap the buffers ...
      const temp = renderTexture
      renderTexture = renderTexture2
      renderTexture2 = temp

      // set the new texture
      outputSprite.texture = renderTexture

      // twist this up!
      // stuffContainer.rotation -= 0.01
      // outputSprite.scale.set(1 + Math.sin(count) * 0.2)

      // render the stage to the texture
      // the 'true' clears the texture before the content is rendered
      app.renderer.render(app.stage, renderTexture2, false)
    })
  }

  function onSegment(err, segmentation) {
    if (err) {
      console.log(err)
      return
    }

    if (maskTexture && mctx) {
      // write image data to our mask canvas
      mctx.globalCompositeOperation = 'source-over'

      // Blur the person mask using quasimondo's stackblur on the raw imageData
      StackBlur.imageDataRGBA(segmentation.raw.personMask, 0, 0, CW, CH, CW / 32)

      // put image data (black and transparent) onto our mask canvas
      mctx.putImageData(segmentation.raw.personMask, 0, 0)

      // fill mask area with white instead of black for pixi
      // (Using our raw mask as a canvas mask as we make our pixi mask)
      mctx.globalCompositeOperation = 'source-in'
      mctx.fillStyle = '#fff'
      mctx.fillRect(0, 0, CW, CH)

      // Tell pixi mask texture to update
      maskTexture.update()
    }

    bodypix.segment(onSegment, bodypixOptions)
  }

  function initGUI() {
    // gui = new dat.GUI()
    // gui.add(bodypixOptions, 'segmentationThreshold', 0.01, 0.99)
    // gui.add(config, 'opacity', 0, 1)
    // gui.add(config, 'smear', 0, 1)
    // gui.add(config, 'zoom', -1, 1)
    // gui.add(config, 'figureBlur', 0, 1)
    // gui.add(config, 'backgroundBlur', 0, 1)
  }

  // const loop = () => {}

  setup()
  initGUI()
}
